/** @jsxImportSource @emotion/react */
import type { ReactNode } from 'react';
import { meterBarStyle, trackStyle, fillStyle } from './MeterBar.styles';

/** 색 계열. 성공률 구간별 색(초록/노랑/빨강)은 호출부의 업무 규칙으로 판정. */
export type MeterBarTone = 'success' | 'warning' | 'danger';

export interface MeterBarProps {
  /** 0~100. */
  percent: number;
  tone?: MeterBarTone;
  /** 우측 라벨. 예: "98%" (선택) */
  label?: ReactNode;
}

/** 미니 수평 게이지. 표 안의 성공률 표시에 활용. */
export function MeterBar({ percent, tone = 'success', label }: MeterBarProps) {
  return (
    <span css={meterBarStyle}>
      <span css={trackStyle}>
        <span css={fillStyle(tone)} style={{ width: `${Math.max(0, Math.min(100, percent))}%` }} />
      </span>
      {label !== undefined && <span>{label}</span>}
    </span>
  );
}
